import { Injectable } from '@angular/core';
declare const FB: any;

@Injectable({
  providedIn: 'root',
})
export class FacebookService {
  private initialized = false;
  private initPromise!: Promise<void>;

  init(): Promise<void> {
    if (this.initialized) {
      return Promise.resolve();
    }

    if (this.initPromise) {
      return this.initPromise;
    }

    this.initPromise = new Promise((resolve) => {
      (window as any).fbAsyncInit = () => {
        FB.init({
          appId: '2319670841850291',
          cookie: true,
          xfbml: false,
          version: 'v19.0',
        });

        this.initialized = true;
        resolve();
      };

      const scriptId = 'facebook-jssdk';

      if (!document.getElementById(scriptId)) {
        const js = document.createElement('script');
        js.id = scriptId;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        js.async = true;
        js.defer = true;

        document.body.appendChild(js);
      }
    });

    return this.initPromise;
  }

  async login(): Promise<string | null> {
    await this.init();

    return new Promise((resolve) => {
      FB.login(
        (response: any) => {
          if (response.authResponse) {
            resolve(response.authResponse.accessToken);
          } else {
            resolve(null);
          }
        },
        { scope: 'email' }
      );
    });
  }
}
